import { useLayoutEffect, useRef, useState } from "react";
import styles from "./styles/Player.module.css";

/**
 * One line of text that scrolls sideways, back and forth, when it is too long to fit, so the whole title can be read.
 * Text that fits stays still; so does everything for listeners who prefer reduced motion (they get an ellipsis).
 */
export const MarqueeText = ({ text }: { text: string }) => {
    const box = useRef<HTMLSpanElement>(null);
    const inner = useRef<HTMLSpanElement>(null);
    const [overflow, setOverflow] = useState(0);

    useLayoutEffect(() => {
        const measure = () => {
            if (box.current && inner.current) {
                setOverflow(Math.max(0, inner.current.scrollWidth - box.current.clientWidth));
            }
        };
        measure();
        if (typeof ResizeObserver === "undefined" || !box.current) return;
        const observer = new ResizeObserver(measure);
        observer.observe(box.current);
        return () => observer.disconnect();
    }, [text]);

    return (
        <span className={styles.marquee} ref={box} title={text}>
            <span
                className={overflow > 0 ? styles.marqueeMoving : styles.marqueeStill}
                ref={inner}
                style={
                    overflow > 0
                        ? ({
                              "--marquee-shift": `-${overflow}px`,
                              // About 30px a second, plus a pause at each end
                              "--marquee-time": `${Math.max(6, overflow / 30 + 3)}s`,
                          } as React.CSSProperties)
                        : undefined
                }>
                {text}
            </span>
        </span>
    );
};
